import { Component } from '@angular/core';

import { AbstractCellComponent } from '@camelot/core';

import { BillingRow } from '../../../../../common/services/dto/row';

@Component({
  host: { 'data-cid': 'grid-billing-percentage-cell' },
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '',
  template: `<div style="font-weight: bold">{{ this.percentage }}</div>`,
})
export class GridBillingPercentageCellComponent extends AbstractCellComponent<BillingRow, number> {
  get percentage() {
    return this.value ? `${this.value}%` : '';
  }
}
